import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { MANAGE_TEACHING_ORDER_COMPONENT } from './types';
import { useManageOptionsProvider } from './ManageOptionsProvider';
import { translate } from 'translations/translator';

const getTranslation = (key: string) => translate('lessonPlanner', key);

const ACTIVE_STYLES: any = {
  borderBottom: ' 4px solid #000000',
  color: '#000000',
  fontWeight: 'bold'
};
const DEFAULT_STYLES: any = {
  borderBottom: ' 1px solid #E0E0E0',
  color: '#6A6A6A',
  fontWeight: 'bold'
};

export const ManageOptionsNav = () => {
  const classes = useStyles()();
  const [{ manageNavType }, { setManageNavType }] = useManageOptionsProvider();

  const handleChange = (_, navType: Array<MANAGE_TEACHING_ORDER_COMPONENT>) => {
    setManageNavType(navType[0]);
  };

  return (
    <Box className={classes.container}>
      <ToggleButtonGroup onChange={handleChange} classes={{ root: classes.container }}>
        <ToggleButton
          size="large"
          className={classes.toggleBtn}
          value={MANAGE_TEACHING_ORDER_COMPONENT.EditStartDate}
          style={
            manageNavType === MANAGE_TEACHING_ORDER_COMPONENT.EditStartDate
              ? ACTIVE_STYLES
              : DEFAULT_STYLES
          }
        >
          {getTranslation('schoolStartDate')}
        </ToggleButton>
        <ToggleButton
          size="large"
          className={classes.toggleBtn}
          value={MANAGE_TEACHING_ORDER_COMPONENT.ManageNonTeachingDays}
          style={
            manageNavType === MANAGE_TEACHING_ORDER_COMPONENT.ManageNonTeachingDays
              ? ACTIVE_STYLES
              : DEFAULT_STYLES
          }
        >
          {getTranslation('nonTeachingDays')}
        </ToggleButton>
        <ToggleButton
          size="large"
          className={classes.toggleBtn}
          value={MANAGE_TEACHING_ORDER_COMPONENT.ManageTeachingOrders}
          style={
            manageNavType === MANAGE_TEACHING_ORDER_COMPONENT.ManageTeachingOrders
              ? ACTIVE_STYLES
              : DEFAULT_STYLES
          }
        >
          {getTranslation('teachingOrders')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    container: {
      display: 'flex',
      flex: 1,
      height: 53,
      margin: '0px -12px'
    },
    toggleBtn: {
      display: 'flex !important',
      flex: 1,
      textTransform: 'none !important',
      width: 100,
      borderTop: 'none !important',
      borderLeft: 'none !important',
      borderRight: 'none !important',
      '&:hover': {
        backgroundColor: 'unset !important'
      },
      '&:disabled': {
        border: 'none'
      }
    } as any
  }));
